import React from "react";
import { Stack, useBreakpointValue, useColorModeValue } from "@chakra-ui/react";
import { TiThumbsUp, TiThumbsDown } from "react-icons/ti";
import { SmallActionButton } from "screens/content/contentCanvas/cell/SmallActionButton";

interface SectionFooterProps {
  children?: React.ReactNode;
}

export const SectionFooter: React.FC<SectionFooterProps> = ({ children }) => {
  const isMobile = useBreakpointValue({ base: true, md: false }, { fallback: "md", ssr: false });
  const borderColor = useColorModeValue("gray.200", "gray.600");

  return (
    <Stack
      height="2rem"
      spacing={isMobile ? ".5rem" : "1rem"}
      width="100%"
      px={isMobile ? ".5rem" : "1rem"}
      py={isMobile ? ".2rem" : ".5rem"}
      direction="row"
      borderTop="1px solid"
      borderColor={borderColor}
      align="center">
      <SmallActionButton classNames="ch-like-section" iconTypeName={TiThumbsUp} tooltip="Like Section" />
      <SmallActionButton classNames="ch-unlike-section" iconTypeName={TiThumbsDown} tooltip="Unlike Section" />
      {children}
    </Stack>
  );
};
